import React, { useState, useContext, useEffect } from 'react';
import { SecretariasContext } from '../../../contexts/secretariasProvider';
import { UserContext } from '../../../contexts/userProvider';
import { ClientContext } from '../../../contexts/clientProvider';
import { FaturadorContext } from '../../../contexts/faturadorProvider';
import BaseInput from '../../General/FormsComp/Input/BaseInput';
import BaseSelect from '../../General/FormsComp/Select/BaseSelect';
import BaseButton from '../../General/FormsComp/Button/BaseButton';
import LoadingSpinner from '../../Loader/load';

const formatCNPJ = (value) => {
  if (!value) return '';
  const cleaned = value.replace(/\D/g, '');
  return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
};



const Visualizar = ({ secretaria, closeModal }) => {
  const { updateSecretaria } = useContext(SecretariasContext);
  const { setAlert } = useContext(UserContext);
  const { clientes } = useContext(ClientContext);
  const { clienteSelecionado, setClienteSelecionado } = useContext(FaturadorContext);
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedClient, setSelectedClient] = useState('');
  const [secretariaData, setSecretariaData] = useState({
    ...secretaria,
    cnpj: formatCNPJ(secretaria?.cnpj || '')
  });

  // Inicializar o cliente selecionado baseado no cliente_id da secretaria
  useEffect(() => {
    if (secretaria?.cliente_id && clientes) {
      const cliente = clientes.find(c => c.id === parseInt(secretaria.cliente_id));
      if (cliente) {
        setSelectedClient(String(cliente.id));
        setClienteSelecionado(cliente.nome);
      }
    }
  }, [secretaria, clientes, setClienteSelecionado]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    let formattedValue = value;
    
    // Formatação automática para campos específicos
    if (name === 'cnpj') {
      formattedValue = formatCNPJ(value);
    }
    
    setSecretariaData(prev => ({
      ...prev,
      [name]: formattedValue
    }));
  };

  const handleSelectClient = (e) => {
    const id = e.target.value;
    setSelectedClient(id);
    const selected = clientes?.find((c) => c.id === parseInt(id));
    if (selected) {
      setClienteSelecionado(selected.nome);
      setSecretariaData(prev => ({
        ...prev,
        cliente_id: id
      }));
    } else {
      setClienteSelecionado('');
      setSecretariaData(prev => ({
        ...prev,
        cliente_id: ''
      }));
    }
  };

  const handleSave = async () => {
    // Validações básicas
    if (!secretariaData.nome) {
      setAlert({
        visible: true,
        title: "Atenção!",
        placeholder: "Nome é obrigatório",
        confirm: false,
        type: "warning",
      });
      return;
    }

    setLoading(true);
    try {
      const result = await updateSecretaria(secretariaData);
      if (result) {
        setIsEditing(false);
        closeModal();
      }
    } catch (error) {
      console.error('Erro ao atualizar secretaria:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setSecretariaData({
      ...secretaria,
      cnpj: formatCNPJ(secretaria?.cnpj || '')
    });
    // Resetar cliente selecionado
    if (secretaria?.cliente_id && clientes) {
      const cliente = clientes.find(c => c.id === parseInt(secretaria.cliente_id));
      if (cliente) {
        setSelectedClient(String(cliente.id));
        setClienteSelecionado(cliente.nome);
      }
    }
    setIsEditing(false);
  };

  if (!secretaria) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-vox-2xl max-w-4xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        {loading && <LoadingSpinner />}
        
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
            {isEditing ? 'Editar Secretaria' : 'Visualizar Secretaria'}
          </h2>
          <button
            onClick={closeModal}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <BaseInput
              label="Nome da Secretaria"
              name="nome"
              value={secretariaData.nome || ''}
              onChange={handleInputChange}
              disabled={!isEditing}
              required
            />
            
            <BaseInput
              label="CNPJ"
              name="cnpj"
              value={secretariaData.cnpj || ''}
              onChange={handleInputChange}
              disabled={!isEditing}
            />
            
                         <BaseInput
               label="Email"
               name="email"
               type="email"
               value={secretariaData.email || ''}
               onChange={handleInputChange}
               disabled={!isEditing}
               required
             />
             
             <BaseSelect
               label="Cliente"
               name="cliente"
               value={selectedClient}
               onChange={handleSelectClient}
               options={clientes ? clientes.slice().sort((a, b) => a.nome.localeCompare(b.nome)) : []}
               placeholder="Selecione o cliente"
               valueKey="id"
               labelKey="nome"
               disabled={!isEditing}
               required
             />
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end space-x-4 p-6 border-t border-gray-200 dark:border-gray-700">
          {!isEditing ? (
            <>
              <BaseButton
                onClick={() => setIsEditing(true)}
                variant="primary"
              >
                Editar
              </BaseButton>
              <BaseButton
                onClick={closeModal}
                variant="secondary"
              >
                Fechar
              </BaseButton>
            </>
          ) : (
            <>
              <BaseButton
                onClick={handleSave}
                variant="primary"
                disabled={loading}
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </BaseButton>
              <BaseButton
                onClick={handleCancel}
                variant="secondary"
              >
                Cancelar
              </BaseButton>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Visualizar;
